import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './transaction-list-item.module.scss';
import { HistIcon } from '../../../../../assets/icons';
import { TitleAndCategory } from '../../../../../model/transaction';


export interface TransactionListItemProps {
  id: string;
  metaData: TitleAndCategory;
  transactionId: string;
  amount: string;
  date: string;
  status: 'successful' | 'pending' | 'aedcPending' | 'failed' | 'refunded' | 'refundInProgress' | 'refundQueued' | 'expired' | 'cancelled' | 'confirmed' | 'declined' | 'unknown';
  onClick?: (id: string, category: number) => void;
  className?: string;
}

export const TransactionListItem: React.FC<TransactionListItemProps> = ({
  id,
  metaData,
  transactionId,
  amount,
  date,
  status,
  onClick,
  className = ''
}) => {
  const { t } = useTranslation();
  const handleClick = () => {
    if (onClick) {
      onClick(id, metaData.category);
    }
  };

  const getStatusClass = () => {
    switch (status) {
      case 'successful':
        return styles.successful;
      case 'pending':
      case 'aedcPending':
        return styles.pending;
      case 'failed':
        return styles.failed;
        case 'refunded':
          return styles.refunded;
        case 'refundInProgress':
          return styles.refundInProgress;
        case 'refundQueued':
          return styles.refundQueued;
        case 'expired':
          return styles.expired;
        case 'cancelled':
          return styles.cancelled;
      default:
        return '';
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'successful':
        return t('common.labels.completed');
      case 'pending':
        return t('common.labels.inProgress');
      case 'aedcPending':
        return t('common.labels.pending');
      case 'failed':
        return t('common.labels.failed');
        case 'refunded':
          return t('history.web.refunded')
        case 'refundInProgress':
          return t('history.refund.inProgressTitle');
        case 'refundQueued':
          return t('history.refund.refundQueued');
        case 'expired':
          return t('common.labels.expired');
        case 'cancelled':
          return t('common.labels.cancelled');
        case 'confirmed':
          return t('common.labels.confirmed');
        case 'declined':
          return t('common.labels.declined');
      default:
        return t('common.labels.unknown');
    }
  };

  return (
    <button
      className={`${styles.transactionItem} ${className}`}
      onClick={handleClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className={styles.iconContainer}>
        {metaData.icon || <HistIcon height={10} />}
      </div>
      
      <div className={styles.content}>
        <div className={styles.leftSection}>
          <h3 className={styles.title}>{metaData.title}</h3>
          {/* <p className={styles.transactionId}>{transactionId}</p> */}
          <p className={styles.date}>{date}</p>
        </div>
        
        <div className={styles.rightSection}>
          <p className={styles.amount}>
            {amount}
          </p>
          
          <span className={`${styles.status} ${getStatusClass()}`}>
            {getStatusText()}
          </span>
        </div>
      </div>
    </button>
  );
};